// Abrir y cerrar con transición algo que se monta y desmonta —
// ADR-2026-09-25-el-selector-de-fuentes-entra-y-sale-con-transicion.
//
// Es el patrón de las hojas de la app (`SheetGenerar`, el sheet "Agregar" del Estudio)
// puesto en un hook: el contenido se monta con su estilo de "cerrado", en el frame
// siguiente pasa al de "abierto" (así hay transición que correr: con el estilo final desde
// el primer paint no hay nada que animar), y al cerrar vuelve al de "cerrado" y recién
// cuando la transición terminó se desmonta.
//
//   • `montado` — si hay que dibujarlo (sigue en `true` mientras sale).
//   • `visible` — qué estilo lleva: el de abierto o el de cerrado.
//
// Dos frames y no uno para la entrada: con uno solo el navegador puede pintar los dos
// estados juntos y el contenido aparece de golpe (es lo que ya anota el sheet "Agregar").

import { useEffect, useState } from 'react';

export function useAperturaAnimada(
  abierto: boolean,
  /** Cuánto dura la transición de salida (ms): es lo que se espera antes de desmontar. */
  duracionMs: number,
): { montado: boolean; visible: boolean } {
  const [montado, setMontado] = useState(abierto);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (abierto) {
      setMontado(true);
      let segundo = 0;
      const primero = window.requestAnimationFrame(() => {
        segundo = window.requestAnimationFrame(() => setVisible(true));
      });
      return () => {
        window.cancelAnimationFrame(primero);
        window.cancelAnimationFrame(segundo);
      };
    }
    setVisible(false);
    const t = window.setTimeout(() => setMontado(false), duracionMs);
    return () => window.clearTimeout(t);
  }, [abierto, duracionMs]);

  return { montado, visible };
}
